import Button from "@material-ui/core/esm/Button";
import EditIcon from "@material-ui/icons/esm/Edit";
import clsx from 'clsx';
import React from 'react';
import useStyles from './ButtonStyles';
export default function EditButton({
  outlined,
  className,
  disabled,
  onClick,
  children,
  size
}) {
  const {
    secondaryButton
  } = useStyles();
  return /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    variant: outlined ? 'outlined' : undefined,
    className: clsx(className, secondaryButton),
    disabled: disabled,
    onClick: onClick,
    size: size,
    startIcon: /*#__PURE__*/React.createElement(EditIcon, null)
  }, children);
}
EditButton.defaultProps = {
  disabled: false,
  className: '',
  outlined: true,
  size: undefined
};